import elementTextFilter from '../../../../modules/Gull/Framework/elementTextFilter.js';

const editView = {
	init() {
		var elementTextFilterElement = document.querySelector('[data-element-text-filter-input]');
		elementTextFilter.init(elementTextFilterElement);
		editView.initEvents();
	},

	initEvents() {
		const rechtenTab = document.querySelector('.nav-link#rechten-tab');
		if (rechtenTab) {
			rechtenTab.addEventListener('click', function () {
				document.querySelector('[data-element-text-filter-input]').focus();
			});
		}
	},
};

export default editView;
